import { useEffect, useState } from 'react'
import { AgGridColumn } from 'ag-grid-react'
import { AgLink } from 'Components/Shared/AgLink'
import Text, { TextTypes } from 'Components/Ui-Kits/Text'
import { Colors } from 'constants/colors'
import { dateTimeFormat } from 'constants/index'
import { formatReceptionLabels } from 'constants/receptions'
import { useAppTranslation } from 'i18n/hooks'
import { array, bool, node, object, string } from 'prop-types'
import { GridWrap } from 'Components/Shared/GridWrap'
import styled from 'styled-components'
import { mapReceptionRows } from 'Components/Reception/utils/receptionCompact'

export const ReceptionStatusGrid = ({ title, receptions, loading, extraFrameworkComponents, children }) => {
  const [grid, setGrid] = useState(null)
  const { t } = useAppTranslation()

  useEffect(() => {
    if (!grid || loading) return

    grid.api.setRowData(mapReceptionRows(receptions, t, dateTimeFormat, formatReceptionLabels))
  }, [receptions, loading, grid, t])

  return (
    <>
      <Text as="h2" type={TextTypes.HEADING_34}>
        {title}
      </Text>
      <GridStyled>
        <GridWrap
          height={400}
          gridOptions={{ headerHeight: 50 }}
          defaultColDef={{
            sortable: true,
            resizable: true,
            autoHeaderHeight: true,
            wrapHeaderText: true,
            headerClass: 'grid_header',
            cellStyle: { display: 'flex', alignItems: 'center' },
          }}
          frameworkComponents={{
            link: AgLink,
            deadline({ value }) {
              return (
                <Text as="span" type={TextTypes.BODY_14} color={value <= 3 ? Colors.MAROON : Colors.BLACK}>
                  {value}
                </Text>
              )
            },
            ...extraFrameworkComponents,
          }}
          rowHeight={60}
          onGridReady={setGrid}
        >
          <AgGridColumn
            field="serialNumber"
            headerName={t('id')}
            cellRenderer="link"
            cellRendererParams={{ to: '/reception/edit/{id}' }}
          />
          <AgGridColumn field="sellerName" headerName={t('sellerName')} />
          <AgGridColumn
            field="holmastoId"
            headerName={t('holmastoId')}
            cellRenderer="link"
            cellRendererParams={{ to: '/clients/{sellerId}/view' }}
          />
          <AgGridColumn field="createdAt" headerName={t('date')} />
          <AgGridColumn field="daysLeft" headerName={t('daysBeforeDeadline')} cellRenderer="deadline" minWidth={180} />
          <AgGridColumn field="purposeOfSale" headerName={t('purposeOfSale')} />
          {children}
        </GridWrap>
      </GridStyled>
    </>
  )
}

ReceptionStatusGrid.propTypes = {
  title: string.isRequired,
  receptions: array,
  loading: bool,
  extraFrameworkComponents: object,
  children: node,
}

const GridStyled = styled.div`
  .ag-header-viewport {
    background-color: ${Colors.DIM_GRAY};
  }

  .ag-header-cell {
    padding-left: 10px !important;
    padding-right: 5px !important;
  }

  .ag-theme-alpine .ag-cell {
    padding-left: 10px !important;
  }
`
